import { render, staticRenderFns } from "./CreateActivityDialog.vue?vue&type=template&id=51cbc794&scoped=true&lang=pug&"
import script from "./CreateActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbc794",
  null
  
)

export default component.exports